import { motion } from "framer-motion";

const chapters = [
    {
        num: "01",
        title: "Made where it matters.",
        body: "Formulated in Rusayl and shipped across the Sultanate. Every batch is engineered for a climate that swings from 48°C desert heat to salt-laden coastal air.",
    },
    {
        num: "02",
        title: "Pigment, not filler.",
        body: "Superior pigments and durable binders — the reason our whites stay white, our reds stay red, and our exteriors hold their colour through the sun's harshest season.",
    },
    {
        num: "03",
        title: "Clean by design.",
        body: "Ammonia-free. Lead-free. Phthalate-free. Formaldehyde-free. What ends up on your wall is colour — not compromise.",
    },
    {
        num: "04",
        title: "Slow enough to last.",
        body: "Our mark is a tortoise for a reason. We move deliberately, test relentlessly, and build finishes that outlive trends.",
    },
];

export const Manifesto = () => {
    return (
        <section id="manifesto" className="relative py-24 md:py-40 bg-bone" data-testid="manifesto-section">
            <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-4">
                        <div className="font-mono text-[10px] uppercase tracking-widest text-ink/50">
                            Manifesto · four movements
                        </div>
                    </div>
                    <div className="col-span-12 md:col-span-8">
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-100px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="font-display text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em]"
                        >
                            A paint house built on{" "}
                            <span className="italic text-brand-red">patience</span>, pigment, and place.
                        </motion.h2>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16 md:gap-y-24">
                    {chapters.map((c, i) => (
                        <motion.div
                            key={c.num}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.9, delay: (i % 2) * 0.15, ease: [0.22, 1, 0.36, 1] }}
                            className={`${i % 2 === 1 ? "md:mt-24" : ""}`}
                            data-testid={`chapter-${c.num}`}
                        >
                            <div className="flex items-baseline gap-6 mb-6">
                                <div className="font-display italic text-6xl md:text-7xl text-brand-red leading-none">
                                    {c.num}
                                </div>
                                <div className="h-px flex-1 bg-ink/20" />
                            </div>
                            <h3 className="font-display text-3xl md:text-4xl leading-tight mb-4">
                                {c.title}
                            </h3>
                            <p className="text-ink/70 text-base md:text-lg max-w-md">{c.body}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
